// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var SalesEntityEditSettingsController = function ($scope, $rootScope, $routeParams, $location, salesEntitiesService) {

    if ($routeParams.salesEntityId) {
        $scope.salesEntity = salesEntitiesService.get({ salesEntityId: $routeParams.salesEntityId });
    } else {
        $scope.salesEntity = new salesEntitiesService();
    }

    function finish() {
        $location.path("/account-settings/salesentities");
    };

    $scope.cancel = finish;

    $scope.save = function () {

        if (!$rootScope.isValid($scope.form)) {
            return;
        }

        if ($routeParams.salesEntityId) {
            $scope.salesEntity.$update({ salesEntityId: $routeParams.salesEntityId }, finish);
        } else {
            $scope.salesEntity.$save({}, finish);
        }
            
    };
};
SalesEntityEditSettingsController.$inject = ['$scope', '$rootScope', '$routeParams', '$location', 'SalesEntities'];
